import React from "react";

const CheckIconReg = React.forwardRef(
    function CheckIconReg(
        {
            title,
            titleId,
            ...props
        },
        svgRef
    ) {
        return (
            <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                ref={svgRef}
                aria-labelledby={titleId}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-check"
                {...props}
            >
                {title ? <title id={titleId}>{title}</title> : null}
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
        );
    }
);

export default CheckIconReg;
